<template>
    <div>
        <sau-template :retrieved="gotData">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Remote Access Details</template>
            <!-- Data -->
            <template slot="data">
                <div class="row" v-if="retrieved">
                    <div class="col">
                        <div class="row pt-2">
                            <div class="col-lg-6 drop">
                                <div class="sau-bx p-6 h-100">
                                    <h5>Username</h5>
                                    <p v-if="accessUsername">{{ accessUsername }}</p>
                                    <p v-else>Not Set</p>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="sau-bx p-6 h-100">
                                    <h5>Password</h5>
                                    <div v-show="!showAccessPassword">
                                        <!-- Match the dots to the password length -->
                                        <template v-if="accessPassword">
                                            <span class="sau-pwd-dot space" v-for="(key, index) in accessPassword.length" :key="index"></span>
                                            <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Show</a>
                                        </template>
                                        <template v-else>
                                            <p>Not Set</p>
                                        </template>
                                    </div>
                                    <div v-show="showAccessPassword">
                                        <span class="clear-password wm-hide">{{ accessPassword }}</span>
                                        <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Hide</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col">

                        <sau-apiro-response type="error" support="true">
                            <template slot="message">There was an issue retrieving your login details.</template>
                            <template slot="details">
                                <p>For more information please contact our Support Team.</p>
                            </template>
                        </sau-apiro-response>

                    </div>
                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showAccessPassword: false,
            retrieved: false,
            accessPassword: '',
            accessUsername: '',
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getLoginDetails().then(response => {
                if(response.data) {
                    this.accessUsername = response.data.username;
                    this.accessPassword = response.data.password;
                }
                this.retrieved = true;
            });
        },
    }
}
</script>
<style>
.space {
    margin:0px 2px;
}
</style>
